// extracted by mini-css-extract-plugin
module.exports = {"dialog_wrapper":"modal_dialog_wrapper__3wHVf","title_wrapper":"modal_title_wrapper__397o6","border_bottom":"modal_border_bottom__p9ASd","address":"modal_address__3B89E"};